import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import ConfigDB from "../../config";
import {
  createVehiclePartsStatuChecklist,
  getVehiclePartsChecklist,
  getVehiclePartsStatusHistoryChecklist,
} from "../../services/PartsInventory";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { getCommonSearchList } from "../../services/settingsServices";
import { toast } from "react-toastify";
import Utils from "../../utils";
import moment from "moment";

const VehiclePartCheckList = ({
  vehicleProcessList,
  vehicleId,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();
  const [vehiclePartCheckList, setVehiclePartCheckList] = useState([]);
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    vehicle_id: vehicleProcessList?.vehicle_id
      ? vehicleProcessList?.vehicle_id
      : vehicleId,
    vehicle_type_id: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [partCheckListStatusList, setPartCheckListStatusList] = useState([]);
  const [vehiclePartCheckData, setVehiclePartCheckData] = useState({});
  const [checkModal, setCheckModal] = useState(false);
  const [isStatusCheckButtonLoad, setIsStatusCheckButtonLoad] = useState(false);
  const [partCheckData, setPartCheckData] = useState("");
  const [satusCheckData, setSatusCheckData] = useState("");
  const [partAddDetails, setPartAddDetails] = useState([]);
  const [modalPartDetails, setModalPartDetails] = useState(false);
  const [partDetailsId, setPartDetailsId] = useState(false);

  const handlePartDetailsClose = () => {
    setModalPartDetails(false);
  };
  const handlePartDetailsOpen = (e, item) => {
    setPartDetailsId(item.part_checklist_id);
    setModalPartDetails(true);
  };
  const onCheckSatusChangeClose = () => {
    setCheckModal(false);
  };

  useEffect(
    function () {
      let obj = { ...params };

      getVehiclePartsChecklist(obj)
        .then((response) => {
          setVehiclePartCheckList(response.data.data);
          setTotalRecords(response.data.total);
        })
        .catch((err) => {});
    },
    [params]
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_parts_checklist_action",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartCheckListStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (!partDetailsId) return;

    const fetchChecklistData = async () => {
      try {
        const data = {
          limit: 30,
          page: 1,
          part_checklist_id: partDetailsId,
        };

        const response = await getVehiclePartsStatusHistoryChecklist(data);
        setPartAddDetails(response.data?.data || []);
      } catch (err) {
        toast.error(Utils.getErrorMessage(err));
      }
    };

    fetchChecklistData();
  }, [partDetailsId]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
    }

    setParams(paramsObj);
  };

  const handleChangePartStatus = (selectedOption, partCatalogId, item) => {
    const updatedStatus = selectedOption.value;

    setVehiclePartCheckData((prevState) => ({
      ...prevState,
      [partCatalogId]: {
        ...(prevState[partCatalogId] || {}),
        status: updatedStatus,
      },
    }));

    setSatusCheckData(selectedOption?.value);

    if (selectedOption?.value) {
      setCheckModal(true);
      setPartCheckData(item);
    }
  };

  const handleSatusCheckListChange = (e) => {
    e.preventDefault();
    setIsStatusCheckButtonLoad(true);
    let data = {
      checklist_id: partCheckData?.id,
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
      part_catalog_id: partCheckData?.part_catalog_id,
      status: satusCheckData,
    };
    createVehiclePartsStatuChecklist(data)
      .then((response) => {
        toast.success(response.data.message);
        setPartCheckData("");
        setCheckModal(false);
        setIsStatusCheckButtonLoad(false);
        let obj = { ...params };

        getVehiclePartsChecklist(obj)
          .then((response) => {
            setVehiclePartCheckList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        setIsStatusCheckButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary">
            <Form method="post">
              <div className="card-body">
                <div className="row justify-content-start mb-5 ms-1 me-1">
                  <React.Fragment>
                    <div className="fileupload-content">
                      <div className="row justify-content-start mt-4 mb-4">
                        <div className="col-md-6">
                          <div
                            className="card-title m-0 float-left"
                            style={{ width: "100%" }}
                          >
                            <input
                              type="text"
                              className="form-control"
                              value={params.search}
                              onChange={(e) => handleParams(e, "search")}
                              placeholder={t("parts_checklist_search_placeholder")}
                              style={{ marginLeft: "5px" }}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12" style={{ marginTop: "10px" }}>
                        <div className="vehicleThBg table-responsive min-height-0 pb-2">
                          <table className="rounded-table table table-striped table-bordered table-hove">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>{t("name")}</th>

                                <th style={{ width: "10%" }}>
                                  {t("description")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("is_default")}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {t("part_check")}
                                </th>
                                <th style={{ width: "10%" }}>{t("action")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {vehiclePartCheckList?.length > 0 ? (
                                vehiclePartCheckList?.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item?.name}</td>
                                    <td>{item?.description}</td>
                                    <td>
                                      {item?.is_default === 1
                                        ? t("is_default_yes")
                                        : t("is_default_no")}
                                    </td>

                                    <td>
                                      <Select
                                        className="my-select-v"
                                        options={partCheckListStatusList}
                                        value={partCheckListStatusList.find(
                                          (option) =>
                                            option.value ===
                                            Number(
                                              vehiclePartCheckData[item?.id]
                                                ?.status ??
                                                item?.part_checklist_status ??
                                                0
                                            )
                                        )}
                                        onChange={(selectedOption) =>
                                          handleChangePartStatus(
                                            selectedOption,
                                            item?.id,
                                            item
                                          )
                                        }
                                        placeholder={t("select_vehicle_part_check")}
                                        isDisabled={
                                          item?.part_converted_status === 1
                                        }
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                      />
                                    </td>
                                    <td>
                                      {item?.part_checklist_status !== 0 && (
                                        <div
                                          className="edit-btn"
                                          onClick={(e) =>
                                            handlePartDetailsOpen(e, item)
                                          }
                                          style={{
                                            marginLeft: "10px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <i className="bi bi-info-circle"></i>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr className="scrollBrdr">
                                  <td colSpan={6}>{t("no_record_found")}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="card-footer clearfix card-footer-part fuelCF">
                        <div className="pagination pagination-sm m-0 float-right">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecords / params.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => handleParams(e, "pagination")}
                            forcePage={params.page - 1}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                </div>
                <div className="back-footer">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <button
                        type="button"
                        className="next-button btn btn-secondary"
                        onClick={() => setActiveTab("depreciation")}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                    <div className="col-4 text-center">
                      <small style={{ color: "#9ca3af" }}>
                        {t("tool_label")}
                      </small>
                    </div>
                    <div className="col-4 text-end">
                      <button
                        type="button"
                        className="btn btn-primary nxt-btn"
                        onClick={() => setActiveTab("vehicle_model_by_vin")}
                      >
                        {t("save_and_continue")}
                        <i className="bi bi-arrow-right ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modal isOpen={checkModal}>
        <ModalHeader>{t("status_change")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("change_status_confirm")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isStatusCheckButtonLoad}
            onClick={onCheckSatusChangeClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isStatusCheckButtonLoad && (
            <button
              color="secondary"
              className={`btn-square`}
              style={{ width: "100px" }}
              onClick={handleSatusCheckListChange}
              type={`button`}
            >
              {t("submit")} <i className="bi bi-check2"></i>
            </button>
          )}
          {isStatusCheckButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading_dots")}
            </button>
          )}
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalPartDetails} size="lg">
        <ModalHeader>{t("parts_checklist_action_history")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          overflowX: "auto",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      >
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>{t("name")}</th>
                              <th>{t("part_checklist_status_name")}</th>
                              <th>{t("created_at")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partAddDetails?.length > 0 ? (
                              partAddDetails?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.name}</td>
                                  <td>{item?.part_checklist_status_name}</td>
                                  <td>
                                    {moment(item?.created_at).format(
                                      "DD-MM-YYYY hh:mm A"
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center text-muted"
                                >
                                  {t("no_reference_part_data")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default VehiclePartCheckList;
